<template>
  <div class="privacy-page">
    <div class="privacy-header">
      <h1>隐私政策</h1>
    </div>
    
    <div class="privacy-content">
      <section class="privacy-section">
        <h2>主体信息</h2>
        <p>本应用由芝韵文化艺术（广州）有限公司（以下简称"我们"）运营和研发。</p>
        <p>公司名称：芝韵文化艺术（广州）有限公司</p>
        <p>注册地址：广州市天河区</p>
        <p>联系方式：</p>
        <ul>
          <li>邮箱：fg2222222@qq.com</li>
          <li>电话：13717478432</li>
        </ul>
      </section>

      <section class="privacy-section">
        <h2>引言</h2>
        <p>幸福输入（以下简称"我们"）非常重视用户的隐私和个人信息保护。本隐私政策旨在向您说明我们如何收集、使用、存储和共享您的个人信息，以及您享有的相关权利。</p>
        <p>本隐私政策适用于幸福输入提供的所有服务。当您使用我们的产品或服务时，即表示您已同意我们按照本隐私政策收集、使用、存储和共享您的相关信息。</p>
        <p><strong>请您务必仔细阅读并理解本隐私政策的全部内容，特别是以粗体标注的条款。如您不同意本隐私政策的任何内容，请勿使用幸福输入。</strong></p>
        <p><strong>重要承诺：我们承诺在您明确同意本隐私政策之前，不会收集任何个人信息。所有数据收集行为（包括第三方SDK的数据收集）均在您同意后进行。</strong></p>
      </section>
      
      <section class="privacy-section">
        <h2>1. 我们收集的信息</h2>
        <p><strong>重要提示：我们仅在获得您的明确同意后收集以下信息，所有数据收集都遵循合法、正当、必要的原则。</strong></p>
        
        <h3>1.1 您主动提供的信息</h3>
        <p>当您注册账号、使用我们的产品或服务时，您可能会向我们提供如下信息：</p>
        <ul>
          <li>账号信息：您在注册和使用我们的服务时所填写的个人信息，如手机号码、电子邮箱</li>
          <li>个人资料：您选择提供的其他信息，如昵称、头像</li>
          <li>反馈信息：您在使用我们的服务过程中向我们提供的反馈、建议和问题报告</li>
        </ul>
        
        <h3>1.2 在您使用服务过程中收集的信息</h3>
        <p><strong>以下信息的收集均在您同意本隐私政策后进行：</strong></p>
        
        <h4>1.2.1 设备信息</h4>
        <ul>
          <li><strong>设备MAC地址：</strong>
            <br>收集目的：用于设备唯一标识，提供个性化输入服务，防止恶意攻击
            <br>收集方式：通过系统API自动获取
            <br>收集范围：设备网络适配器的MAC地址</li>
          <li><strong>设备型号、操作系统版本：</strong>
            <br>收集目的：优化应用兼容性，提供适配的功能服务
            <br>收集方式：通过系统API自动获取
            <br>收集范围：设备品牌、型号、Android/iOS版本号</li>
          <li><strong>唯一设备标识符（IMEI/Android ID）：</strong>
            <br>收集目的：设备识别、防止账号异常登录
            <br>收集方式：通过系统API获取（需要权限授权）
            <br>收集范围：设备的IMEI号或Android ID</li>
        </ul>
        
        <h4>1.2.2 软件安装列表</h4>
        <ul>
          <li><strong>已安装应用列表：</strong>
            <br>收集目的：为您推荐相关输入法功能，提供更好的用户体验
            <br>收集方式：通过PackageManager API获取
            <br>收集范围：已安装应用的包名、版本信息</li>
        </ul>
        
        <h4>1.2.3 存储访问信息</h4>
        <ul>
          <li><strong>SD卡数据访问：</strong>
            <br>收集目的：保存输入法设置配置、用户词库、皮肤资源
            <br>收集方式：通过存储权限访问指定目录
            <br>收集范围：仅访问应用专用目录下的配置文件和资源文件，不读取其他个人文件</li>
        </ul>
        
        <h4>1.2.4 通讯录和短信（仅在明确授权时）</h4>
        <ul>
          <li><strong>通讯录信息：</strong>
            <br>收集目的：为您提供联系人姓名快速输入功能
            <br>收集方式：在您明确授权后通过ContactsContract API读取
            <br>收集范围：联系人姓名信息（不包含电话号码和其他个人信息）</li>
          <li><strong>短信内容：</strong>
            <br>收集目的：为您提供验证码自动填充功能
            <br>收集方式：在您明确授权后读取短信验证码
            <br>收集范围：仅读取包含验证码的短信内容，不保存完整短信信息</li>
        </ul>
        
        <h4>1.2.5 其他信息</h4>
        <ul>
          <li>日志信息：IP地址、浏览器类型、使用的语言、访问日期和时间</li>
          <li>位置信息：在您授权后收集位置信息，用于提供地理位置相关的输入建议</li>
          <li>输入习惯数据：输入频率、常用词汇（不包含具体输入内容）</li>
        </ul>
        
        <p><strong>请注意：我们不会收集您的具体输入内容，不会读取您的聊天记录、密码或其他敏感个人信息。</strong></p>
        
        <h3>1.3 第三方SDK信息收集</h3>
        <p>为提供更好的服务，我们的应用集成了以下第三方SDK，这些SDK可能会收集您的个人信息：</p>
        
        <h4>1.3.1 APP支付客户端SDK</h4>
        <ul>
          <li><strong>SDK名称：</strong>APP支付客户端SDK</li>
          <li><strong>开发者：</strong>支付宝(杭州)信息技术有限公司</li>
          <li><strong>收集的信息类型：</strong>
            <br>• 设备信息（设备型号、操作系统版本）
            <br>• 网络信息（IP地址、网络状态）
            <br>• 应用信息（应用版本、应用标识）</li>
          <li><strong>收集目的：</strong>提供支付服务、风险识别、反欺诈</li>
          <li><strong>收集方式：</strong>通过系统API自动获取（仅在您同意隐私政策后）</li>
          <li><strong>SDK隐私政策链接：</strong><a href="https://opendocs.alipay.com/open/54/01g6qm#%E6%94%AF%E4%BB%98%E5%AE%9D%20App%20%E6%94%AF%E4%BB%98%E5%AE%A2%E6%88%B7%E7%AB%AF%20SDK%20%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96" target="_blank">https://opendocs.alipay.com/open/54/01g6qm#%E6%94%AF%E4%BB%98%E5%AE%9D%20App%20%E6%94%AF%E4%BB%98%E5%AE%A2%E6%88%B7%E7%AB%AF%20SDK%20%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96</a></li>
        </ul>
        
        <h4>1.3.2 对象存储OSS Android SDK</h4>
        <ul>
          <li><strong>SDK名称：</strong>对象存储OSS Android SDK</li>
          <li><strong>开发者：</strong>阿里云计算有限公司</li>
          <li><strong>收集的信息类型：</strong>
            <br>• 设备信息（设备型号、操作系统版本、设备标识）
            <br>• 网络信息（IP地址、网络状态）
            <br>• 应用信息（应用版本、应用包名）
            <br>• 存储访问权限（用于文件上传下载）</li>
          <li><strong>收集目的：</strong>提供对象存储服务、文件上传下载、服务质量监控</li>
          <li><strong>收集方式：</strong>通过系统API自动获取（仅在您同意隐私政策后）</li>
          <li><strong>SDK隐私政策链接：</strong><a href="https://terms.alicdn.com/legal-agreement/terms/privacy_policy_full/20240202100310511/20240202100310511.html" target="_blank">https://terms.alicdn.com/legal-agreement/terms/privacy_policy_full/20240202100310511/20240202100310511.html</a></li>
        </ul>
        
        <h4>1.3.3 微信OpenSDK Android</h4>
        <ul>
          <li><strong>SDK名称：</strong>微信OpenSDK Android</li>
          <li><strong>开发者：</strong>深圳市腾讯计算机系统有限公司</li>
          <li><strong>收集的信息类型：</strong>
            <br>• 设备信息（设备型号、操作系统版本、设备标识）
            <br>• 网络信息（IP地址、网络状态）
            <br>• 应用信息（应用版本、应用包名）
            <br>• 微信登录授权信息</li>
          <li><strong>收集目的：</strong>提供微信登录、分享功能、用户身份验证</li>
          <li><strong>收集方式：</strong>通过系统API和微信授权获取（仅在您同意隐私政策后）</li>
          <li><strong>SDK隐私政策链接：</strong><a href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8" target="_blank">https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</a></li>
        </ul>
        
        <p><strong>重要说明：</strong></p>
        <ul>
          <li>所有第三方SDK的信息收集行为均在您同意本隐私政策后进行</li>
          <li>我们要求所有第三方服务提供商严格遵循数据保护法律法规</li>
          <li>上述SDK信息已根据全国SDK管理服务平台（https://sdk.caict.ac.cn/official/#/home）登记情况准确公示</li>
          <li>如有SDK信息更新，我们将及时修改隐私政策并通知用户</li>
        </ul>
      </section>
      
      <section class="privacy-section">
        <h2>2. 我们如何使用收集的信息</h2>
        <p>我们可能将收集的信息用于下列用途：</p>
        <ul>
          <li>提供、维护和改进我们的产品和服务。</li>
          <li>了解您如何使用我们的服务，以便我们可以改进现有服务并开发新功能。</li>
          <li>向您提供个性化的服务体验和内容，包括广告推送和内容推荐。</li>
          <li>进行数据分析，以便改进我们的产品和服务。</li>
          <li>防止、检测和调查可能存在的欺诈、安全问题或技术问题。</li>
          <li>履行我们的法律义务，以及执行我们的用户协议或本隐私政策。</li>
        </ul>
      </section>
      
      <section class="privacy-section">
        <h2>3. 信息的共享与披露</h2>
        <p>我们对您的个人信息严格保密。除非以下情况，否则不会向第三方共享您的个人信息：</p>
        <ul>
          <li>获得您的明确授权或同意。</li>
          <li>为了提供您所要求的服务，与必要的第三方服务提供商共享信息。我们要求这些第三方服务提供商按照我们的指示处理个人信息，并采取适当的保密和安全措施。</li>
          <li>根据适用的法律法规、法律程序或政府强制性要求必须披露的情况。</li>
          <li>在涉及合并、收购或资产出售时，如果个人信息转让是其中一部分，我们将确保个人信息得到适当保护。</li>
        </ul>
        <p>我们可能会与我们的合作伙伴共享经去标识化或匿名化处理后的信息，这些信息将无法识别您的个人身份。</p>
      </section>
      
      <section class="privacy-section">
        <h2>4. 信息安全</h2>
        <p>我们致力于保护您的个人信息安全。我们采取了适当的技术和组织措施来保护您的个人信息不被未经授权的访问、披露、使用、修改或损坏。尽管如此，请注意任何互联网传输或电子存储方法都不是100%安全的。</p>
        <p>我们将根据适用法律的要求，在合理的时间内尽最大努力通知您任何关于您个人信息的安全事件。</p>
      </section>
      
      <section class="privacy-section">
        <h2>5. 您的权利</h2>
        <p>根据适用的法律，您可能有权：</p>
        <ul>
          <li>访问您的个人信息</li>
          <li>更正不准确的信息</li>
          <li>删除您的个人信息</li>
          <li>限制或反对某些对您个人信息的处理</li>
          <li>请求将您的个人信息转移给您或另一服务提供商</li>
          <li>撤回您之前的同意</li>
        </ul>
        <p>如果您想行使这些权利，请通过本隐私政策底部的联系方式与我们联系。请注意，在特定情况下，我们可能会根据适用法律拒绝处理您的请求。</p>
      </section>

      <section class="privacy-section">
  <h2>5.1 账号注销规则</h2>
  <p>您有权注销您在幸福输入中注册的账号。注销账号后，我们将停止为您提供产品与服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。</p>
  <p>您可以通过以下方式注销您的账号：</p>
  <ul>
    <li><strong>应用内注销：</strong>在幸福输入应用内，进入"个人中心"→"账号管理栏目"→"注销账号"，按照提示完成注销流程。</li>
    <li><strong>客服电话注销：</strong>拨打客服电话 13717478432，由客服人员协助您完成账号注销。</li>
    <li><strong>邮件注销：</strong>向 fg2222222@qq.com 发送账号注销申请，邮件主题请注明"账号注销申请"，并在邮件中提供您的账号信息和注销原因。我们将在收到邮件后的 15 个工作日内处理您的注销请求。</li>
    <li><strong>官网在线注销：</strong>访问我们的官方网站，在"用户中心"→"账号管理"页面申请注销账号。</li>
  </ul>
  <p><strong>请注意：</strong></p>
  <ul>
    <li>账号注销后，您将无法恢复该账号，也无法再次使用该账号登录幸福输入。</li>
    <li>账号注销后，与该账号相关的个人信息将被删除或匿名化处理，但法律法规要求保留的信息除外。</li>
    <li>如您的账号存在未完成的交易、资金余额、未解决的纠纷或投诉等情况，可能无法立即完成注销。</li>
    <li>为了保障您的账号安全，我们可能会要求您提供身份验证信息，以确认您是账号的实际持有人。</li>
  </ul>
</section>
      
      <section class="privacy-section">
        <h2>6. 儿童隐私</h2>
        <p>我们的服务不面向16岁以下的儿童。如果您是父母或监护人，并且发现您的孩子向我们提供了个人信息，请通过本隐私政策中提供的联系方式与我们联系，我们将采取措施从我们的系统中删除该信息。</p>
      </section>
      
      <section class="privacy-section">
        <h2>7. 隐私政策的更新</h2>
        <p>我们可能会不时更新本隐私政策。当我们对隐私政策作出重大更改时，我们会在应用内显著位置发布通知，并在必要时取得您的同意。</p>
        <p>我们建议您定期查看本隐私政策，以了解我们的信息处理实践的最新情况。当您继续使用我们的服务时，即表示您接受经修订的隐私政策。</p>
      </section>
      
      <section class="privacy-section">
        <h2>8. 联系我们</h2>
        <p>如果您对本隐私政策有任何疑问、意见或建议，请通过以下方式与我们联系：</p>
        <p>电子邮件：fg2222222@qq.com</p>
        <p>我们会在收到您的请求后的合理时间内予以回复。</p>
      </section>
      
      <section class="privacy-section">
        <h2>9. 权限使用说明</h2>
        <p>为了提供相应的功能和服务，我们的应用可能会申请以下系统权限：</p>
        <ul>
          <li><strong>存储权限（READ_EXTERNAL_STORAGE / WRITE_EXTERNAL_STORAGE）：</strong>用于读写应用配置文件、用户词库和皮肤资源，不会访问您的个人文件</li>
          <li><strong>设备信息权限（READ_PHONE_STATE）：</strong>用于获取设备IMEI和设备信息，仅用于设备识别</li>
          <li><strong>网络权限（INTERNET / ACCESS_NETWORK_STATE）：</strong>用于网络连接和云端服务</li>
          <li><strong>通讯录权限（READ_CONTACTS）：</strong>可选权限，用于联系人姓名快速输入功能</li>
          <li><strong>短信权限（READ_SMS）：</strong>可选权限，用于验证码自动填充功能</li>
          <li><strong>位置权限（ACCESS_FINE_LOCATION / ACCESS_COARSE_LOCATION）：</strong>可选权限，用于提供地理位置相关的输入建议</li>
        </ul>
        <p><strong>您可以在设备的系统设置中随时撤销这些权限，但这可能会影响相关功能的正常使用。</strong></p>
      </section>
      
      <div class="privacy-footer">
        <p>最后更新日期：2024年12月21日</p>
        <p><strong>重要更新：</strong>根据工信部SDK合规要求，已更新第三方SDK信息披露内容</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPage',
  metaInfo: {
    title: '隐私政策 - 幸福输入'
  }
}
</script>

<style scoped>
.privacy-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: 'Poppins', 'Helvetica Neue', Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}

.privacy-header {
  margin-bottom: 30px;
  text-align: center;
  position: relative;
}

.back-link {
  position: absolute;
  left: 0;
  top: 10px;
  color: #6C63FF;
  text-decoration: none;
  display: flex;
  align-items: center;
  font-size: 14px;
}

.back-icon {
  margin-right: 5px;
  font-size: 18px;
}

.privacy-header h1 {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #333;
}

.privacy-content {
  background-color: white;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
}

.privacy-section {
  margin-bottom: 30px;
}

.privacy-section h2 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.privacy-section h3 {
  font-size: 18px;
  font-weight: 600;
  margin: 20px 0 10px;
  color: #444;
}

.privacy-section p {
  margin-bottom: 15px;
  font-size: 15px;
}

.privacy-section ul {
  margin-bottom: 15px;
  padding-left: 20px;
}

.privacy-section li {
  margin-bottom: 8px;
  font-size: 15px;
}

.privacy-section strong {
  font-weight: 600;
}

.privacy-footer {
  text-align: right;
  margin-top: 40px;
  color: #888;
  font-size: 14px;
}

@media (max-width: 768px) {
  .privacy-page {
    padding: 20px 15px;
  }
  
  .privacy-content {
    padding: 20px;
  }
  
  .privacy-header h1 {
    font-size: 24px;
  }
  
  .privacy-section h2 {
    font-size: 18px;
  }
  
  .privacy-section h3 {
    font-size: 16px;
  }
  
  .privacy-section p,
  .privacy-section li {
    font-size: 14px;
  }
}
</style> 